import * as React from "react";
import { ODataParams, Query } from "../Components/Query";
import { DocumentsWidgetTable } from "./DocumentsWidgetTable";
import { useCookies } from 'react-cookie';
import { Authorization } from "../misc/components/Authorization";
import { useSecurityContext } from "../Core/SecurityContext";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { ErrorBoundary } from "../errors/ErrorBoundary";
import LoadingWithMessage from "../misc/components/LoadingWithMessage";
import { useWebPortalApiClient } from "../misc/api/WebPortalTokenClient";
declare const rootUrl;

export const DocumentsWidgetApp = () => {
    const [allStudySelected, setAllStudySelected] = React.useState(true);
    const [cookies] = useCookies(['WpCurrentStudy']);
    const [studyId, setStudyId] = React.useState<string | null>(cookies.WpCurrentStudy);
    const client = useWebPortalApiClient();

    const { currentUserPermissions } = useSecurityContext();
    const ignoreFileType = "text/xml";

    const handleRefresh = async (params: ODataParams) => {
        let filter = params.filter ? `(${params.filter}) and ` : '';

        setAllStudySelected(studyId === null);

        filter += `contentType ne '${ignoreFileType}' and fullFilePath eq null and studies/any(s: s/studyId eq ${studyId})`;

        return await client.client.getFiles(undefined, filter, params.orderby, undefined, params.top, params.skip, undefined, true);
    }

    if (!studyId)
        return <LoadingWithMessage message="Loading Documents Widget..." />

    return (
        <ErrorBoundary>
            <Authorization studyId={studyId} currentPermissions={currentUserPermissions} permissionId={PermissionEnum.ViewDocumentsWidget}>
                <div className="col-md-6">
                    <div id="DocumentsWidget" className="ibox">
                        <div className="ibox-title">
                            <h5 className="text-primary">Documents</h5>
                        </div>
                        <Query onRefresh={handleRefresh} initialOrdering={[{ field: "fileName", condition: "asc" }]}>
                            <DocumentsWidgetTable allStudySelected={allStudySelected} />
                        </Query>
                    </div>
                </div>
            </Authorization>
        </ErrorBoundary>
    );
}
